// removed by extract-text-webpack-plugin
module.exports = {"Pending":"pending__Pending__Q7D5y","dot1":"pending__dot1__1RcaX","visibility":"pending__visibility__3bN0Z","dot2":"pending__dot2__vSz9C","visibility2":"pending__visibility2__Evit_","dot3":"pending__dot3__DSn9r","visibility3":"pending__visibility3__3OgGN"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Chat/pending.css
// module id = 859
// module chunks = 2